<template>
  <div class="device-report">
    <el-button
      type="text"
      size="mini"
      style="color: #8a8686"
      @click="clearReportFunc"
      icon="el-icon-close"
      :title="$t('清空报告')"
    ></el-button>
    <scrollbar v-if="reportArray.length > 0 && !isHisDetail" type="thin">
      <ul slot="scrollbar">
        <!-- eslint-disable-next-line vue/require-v-for-key -->
        <li
          v-for="item in reportArray"
          :key="item.reportId"
          :class="item | filterWsData | stateClass"
        >
          {{ reportText(item) }}
        </li>
      </ul>
    </scrollbar>
    <div v-else class="no-data">{{ $t('暂无数据') }}</div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

import Type from '@/store/mutation-type';
import ReportMixin from '@/mixins/reportMixin';

export default {
  name: 'deviceReport',
  sockets: {
    '/socket/login'(res) {
      this.getDeviceRport(res);
    },
    '/socket/basic'(res) {
      if (this.fontBasicReport) {
        if (res.beginTime - this.fontBasicReport.beginTime > 2001) {
          this.getDeviceRport(res);
          this.fontBasicReport = res;
        }
      } else {
        this.fontBasicReport = res;
      }
    },
    '/socket/alarm'(res) {
      this.getDeviceRport(res);
    },
    '/socket/param'(res) {
      this.getDeviceRport(res);
    }
  },
  mixins: [ReportMixin],
  props: {
    isHisDetail: {
      type: Boolean,
      default: false
    },
    clearReport: {
      type: Function,
      required: false
    },
    reportArray: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      fontBasicReport: ''
    };
  },
  methods: {
    ...mapMutations('socket', {
      clearReportMut: Type.CLEAR_REPORT,
      getDeviceRport: Type.GET_DEVICE_REPORT
    }),
    clearReportFunc() {
      if (this.clearReport) this.clearReport();
      else this.clearReportMut();
    }
  }
};
</script>

<style lang="scss">
.device-report {
  height: 100%;
  box-sizing: border-box;
  padding: 15px 20px 0;
  margin-top: 16px;
  background-color: rgba(18, 30, 44, 0.6);
  position: relative;
  .no-data {
    height: 100%;
    line-height: 3;
    text-align: center;
    font-size: 14px;
    color: $normal-color;
  }
  .el-button {
    position: absolute;
    right: 45px;
    top: 15px;
  }
  ul {
    list-style: disc inside;
    font-size: 12px;
    height: 100%;
    li {
      padding: 5px 0;
      word-wrap: break-word;
      @include state-textstyle;
    }
  }
}
</style>
